import urls from 'Source/urls';

export const investigateUrlsGroup = [
  urls.investigate.home(),
  urls.investigate.search(),
  urls.investigate.searchRelay.alertEvents(),
  urls.investigate.searchRelay.keyValue(),
  urls.investigate.searchRelay.logType(),
  urls.investigate.searchRelay.dashboardWidget(),
  urls.investigate.dataExplorer(),
  `${urls.investigate.home()}saved-queries/`,
  urls.investigate.savedSearches.list(),
  `${urls.investigate.home()}query-history/`,
  urls.investigate.searchHistory(),
  urls.investigate.cloudResources.list(),
  urls.investigate.cloudResources.details(':id'),
];
